import DefaultPage from "./default-page";

export default function Error() {
  return (
    <DefaultPage>
      <h1>Error 404: Hier gibts nicht zu sehen</h1>
    </DefaultPage>
  );
}
